import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GameService } from '../../shared/services/game.service';
import { APP_ROLE, SOCKET_ERROR, SocketService } from '../../shared/services/socket.service';
import { StorageService } from '../../shared/services/storage.service';


@Injectable()
export class CanActivateRemoteGameGuard implements CanActivate {
  constructor(private _socketService: SocketService, private _gameService: GameService, private _storageService: StorageService, private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this._storageService.getSessionCode().map((sessionCode) => {
      if (sessionCode == null) {
        console.warn('no sessionCode found');
        return Observable.of(false);
      } else {
        console.log('sessionCode found:', sessionCode);
        if (this._socketService.connected === false) {
          console.warn('socket not connected!');
          this._gameService.sessionCode = sessionCode;
          this._socketService.initSocket(sessionCode, APP_ROLE.REMOTE_ROLE);

          const onConnection = this._socketService.onRemoteConnection().map(() => {
            console.log('socket onRemoteConnection');
            return true;
          });
          const onError = this._socketService.onSocketError().map((error: { errorType: SOCKET_ERROR }) => {
            console.log('socket error', error.errorType);
            switch (error.errorType) {
              case SOCKET_ERROR.NO_SESSION_DETECTED:
                this._storageService.clearSessionCode().subscribe(data => {
                  this._gameService.sessionCode = '';
                  console.log('sessionCode cleared local:', data);
                  return false;
                });
                return false;
              case SOCKET_ERROR.MISSING_SESSION_CODE_AND_ROLE:
                return false;
              case SOCKET_ERROR.NO_REMOTE_DETECTED:
                return false;
              default:
                return false
            }
          });

          return Observable.merge(onConnection, onError).take(1);
        } else {
          return Observable.of(true);
        }
      }
    }).flatMap((e: Observable<boolean>) => {
      return e.map((val) => {
        if (val === true) {
          return true;
        } else {
          this._router.navigate(['/remote/settings']);
          return false;
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/remote/game/can-activate-remote-game.guard.ts